import { Auth } from "aws-amplify";
import { getSpeak2Profile } from "../Apps/Speak2ContentAPIs/Speak2Profile";
import {
  isCorporateProfile,
  readActiveCorporateFacility,
} from "./corporateFacilityStorage";

/**
 * Resolve first route after successful authentication (Speak2 / OAuth redirect).
 */
export async function getPostLoginPath() {
  const isSpeak2 = localStorage.getItem("wasSpeak2User") === "true";
  if (!isSpeak2) {
    return "/slideapp";
  }

  try {
    const res = await getSpeak2Profile();
    if (res?.data?.Success !== true) {
      return "/slideapp";
    }
    const content = res.data.Content;
    if (!isCorporateProfile(content)) {
      return "/slideapp";
    }
    const user = await Auth.currentAuthenticatedUser();
    const userId = user?.signInUserSession?.idToken?.payload?.sub;
    const active = readActiveCorporateFacility(userId);
    if (active?.facilityId) {
      return "/slideapp";
    }
    return "/corporate-communities";
  } catch (e) {
    console.log("getPostLoginPath error", e);
    return "/slideapp";
  }
}
